import { Link } from 'react-router-dom';
import ArticleCard from '../../../components/base/ArticleCard';
import { useArticles } from '../../../hooks/useArticles';

const LatestArticles = () => {
  const { articles, loading } = useArticles();
  const latestArticles = articles.slice(0, 6);

  if (loading) {
    return (
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a1a1a]"></div>
            <p className="mt-4 text-gray-600">Chargement des articles...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif font-bold text-[#1a1a1a] mb-4">
            Dernières analyses
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Décryptages, enquêtes et analyses des mouvements sociaux et enjeux démocratiques contemporains
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          {latestArticles.map((article) => (
            <ArticleCard 
              key={article.id} 
              id={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.meta_description || article.content.substring(0, 150) + '...'}
              image={article.image_url || 'https://public.readdy.ai/ai/img_res/b56b3dfd98a1b9ed80d6321a5614a55c.jpg'}
              date={new Date(article.published_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
              readTime={article.readTime || '5 min'}
              category={article.category || 'Article'}
              categoryColor="bg-blue-100 text-blue-800"
              author={article.author || 'Équipe Giletau'}
            />
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 bg-[#1a1a1a] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#2a2a2a] transition-all whitespace-nowrap cursor-pointer"
          >
            Voir tous les articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestArticles;
